import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {DirtyWildsSpineAnimationNames} from "../../../../config/DirtyWildsSpineAnimationNames";
import {DirtyWildsGameAssets} from "../../../DirtyWildsGameAssets";
import {DirtyWildsSoundConfig} from "../../../DirtyWildsSoundConfig";


/**
 * Class description
 *
 * Created: 2018-09-28
 * @author jonas
 */
export class MultiplierCounterDisplay extends PIXI.Container {
    private _dots:PIXI.spine.Spine[];
    private _woosh:PIXI.spine.Spine;
    private _currentIndex:number;
    private _isActive:boolean[];

    constructor() {
        super();

        this.createDots();
        this._currentIndex = -1;
        this._isActive = [false, false, false];
    }

    private createDots() {
        const dot1 = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.MULTIPLIER_FIRE_SQUARE));
        const dot2 = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.MULTIPLIER_FIRE_SQUARE));
        const dot3 = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.MULTIPLIER_FIRE_SQUARE));
        this.addChild(dot1);
        this.addChild(dot2);
        this.addChild(dot3);
        dot1.position.set(0, 0);
        dot2.position.set(44, 0);
        dot3.position.set(90, 0);

        this._dots = [
            dot1,
            dot2,
            dot3
        ];
    }

    public setNumberOfDots(numberOfDots:number, isDoubleWild:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let boxAnim:any = {
            squareStart : DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_START,
            squareLoop : DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_LOOP,
            squareStop : DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_STOP
        };
        if(isDoubleWild) {
            boxAnim = {
                squareStart : DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_START_GREEN,
                squareLoop : DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_LOOP_GREEN,
                squareStop : DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_STOP_GREEN
            };
        }
        const shouldBeActive:boolean[] = [
            numberOfDots >= 1,
            numberOfDots >= 2,
            numberOfDots >= 3,
        ];

        const startUps:TimelineLite[] = [];
        const stops:TimelineLite[] = [];

        for(let i:number = 0; i < this._dots.length; i++) {
            const dotTl = new TimelineLite();
            const dot:PIXI.spine.Spine = this._dots[i];
            const dotWantsActive:boolean = shouldBeActive[i];
            const dotIsActive:boolean = this._isActive[i];
            dot.state.timeScale = 3;
            if(isDoubleWild && dotWantsActive && dotIsActive) {
                dotTl.add(() => new SpineTween(dot, 0, DirtyWildsSpineAnimationNames.MULTIPLIER_FIRE_SQUARE_LOOP_RED_TO_GREEN, -1));
                startUps.push(dotTl);
            }
            if(dotWantsActive && !dotIsActive) {
                dotTl.add(() => SlotGame.sound.playEffect(DirtyWildsSoundConfig.MULTIPLIER_INDEX_UP));
                dotTl.add(new SpineTween(dot, 0, boxAnim.squareStart));
                dotTl.add(() => new SpineTween(dot, 0, boxAnim.squareLoop, -1));
                startUps.push(dotTl);
            }

            if(dotIsActive && !dotWantsActive) {
                dotTl.add(new SpineTween(dot, 0, boxAnim.squareStop));

                stops.push(dotTl);
            }
        }


        this._isActive = shouldBeActive;

        tl.add(startUps, 0, "start", 0.05);
        tl.add(stops, 0, "start", 0);


        return tl;
    }
}